export enum ProductTierEnum {
  TIER_1 = 1,
  TIER_2 = 2,
}
